/// <reference path="../../@types/index.d.ts" />
// /\ needed to compiled docs properly
import * as tslib_1 from "tslib";
import * as React from "react";
import { ErrorLogger } from "../../helpers";
import { DefaultError } from "../DefaultError";
/**
 * ErrorBoundary creates react component that is wrapping
 * all other components activated through BaseBlock thus giving fallback
 * from errors and hoocking up to our error logging service inside the responsive project.
 *
 * Shows {DefaultError} component if error arises.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.logger = new ErrorLogger();
        _this.state = { error: undefined, info: undefined };
        return _this;
    }
    // this one is actually covered, but the library can't understand that
    // React is handling internaly with try/catch and calling this method
    /**
     * Overrides inherited componentDidCatch method
     * @param {Error} error
     * @param {ErrorInfo} errorInfo
     */
    /* istanbul ignore next */
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        /* istanbul ignore next */
        var err = { error: error, info: errorInfo };
        /* istanbul ignore next */
        this.setState(err);
        /* istanbul ignore next */
        this.logger.log({
            error: err.error.toString(),
            stack: err.info.componentStack
        });
    };
    // <DefaultError /> is tested separately
    /**
     * If error, show the <DefaultError />
     */
    ErrorBoundary.prototype.renderError = function () {
        /* istanbul ignore next */
        return React.createElement(DefaultError, { componentStack: this.state.info.componentStack, error: this.state.error });
    };
    /**
     * If all is okay, just pass through the children
     */
    ErrorBoundary.prototype.renderComp = function () {
        return React.createElement("sb-comp", null, this.props.children);
    };
    ErrorBoundary.prototype.render = function () {
        var action = this.state.info ? "Error" : "Comp";
        return this["render" + action]();
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
//# sourceMappingURL=ErrorBoundary.js.map